export const ACTIVITY_ICON_COLOR_LIST = [
    {
        id: 1,
        colorClass: 'bg-email',
        icon: 'pi pi-envelope',
        activityNames: ['Email'],
        activityName: "Emails",
        types: [],
        subTypes: [],
        counts: 0
    },
    {
        id: 2,
        colorClass: 'bg-opportunity',
        icon: 'pi pi-ticket',
        activityNames: ['ActivityFeed'],
        activityName: "Tasks",
        types: ['Task'],
        subTypes: [],
        counts: 0
    },
    {
        id: 3,
        colorClass: 'bg-log',
        icon: 'pi pi-ticket',
        activityNames: ['ActivityFeed'],
        activityName: "Other Activities",
        types: null,
        subTypes: [],
        counts: 0
    },
    {
        id: 4,
        colorClass: 'bg-log email',
        icon: 'pi pi-envelope',
        activityNames: ['Log'],
        activityName: "Email Logs",
        types: ['Email'],
        subTypes: [],
        counts: 0
    },
    {
        id: 21,
        colorClass: 'bg-log mobile',
        icon: 'fa fa-microphone',
        activityNames: ['Log'],
        activityName: "Voice Mail Logs",
        types: ['Voice Mail'],
        subTypes: [],
        counts: 0
    },
    {
        id: 5,
        colorClass: 'bg-log field visit',
        icon: 'pi pi-map-marker',
        activityNames: ['Log'],
        activityName: "Field Visit Logs",
        types: ['Field Visit'],
        subTypes: [],
        counts: 0
    },
    {
        id: 6,
        colorClass: 'bg-log note',
        icon: 'fa fa-pencil-square-o',
        activityNames: ['Log'],
        activityName: "Notes",
        types: ['Note'],
        subTypes: [],
        counts: 0
    },
    {
        id: 7,
        colorClass: 'bg-log mobile',
        icon: 'pi pi-envelope',
        activityNames: ['Log'],
        activityName: "Mobile/Work Inbound Call",
        types: ['Mobile','Work'],
        subTypes: ['Inbound Call'],
        counts: 0
    },
    {
        id: 8,
        colorClass: 'bg-log mobile',
        icon: 'pi pi-envelope',
        activityNames: ['Log'],
        activityName: "Mobile/Work Outbound Call",
        types: ['Mobile','Work'],
        subTypes: ['Outbound Call'],
        counts: 0
    },
    {
        id: 9,
        colorClass: 'bg-log',
        icon: 'pi pi-ticket',
        activityNames: ['ActivityFeed'],
        activityName: "User Assigned",
        types: ['AssignUser'],
        subTypes: [],
        counts: 0
    },
    {
        id: 10,
        colorClass: 'bg-log',
        icon: 'pi pi-map-marker',
        activityNames: ['ActivityFeed'],
        activityName: "Check In/Check Out",
        types: ['CheckIn','CheckOut'],
        subTypes: [],
        counts: 0
    },
    {
        id: 11,
        colorClass: 'bg-event',
        icon: 'pi pi-map-marker',
        activityNames: ['ActivityFeed'],
        activityName: "Address Latitude/Longitude Updated",
        types: ['AddressChange'],
        subTypes: [],
        counts: 0
    },
    {
        id: 12,
        colorClass: 'bg-note',
        icon: 'pi pi-user-edit',
        activityNames: ['Note'],
        activityName: "Notes",
        types: [],
        subTypes: [],
        counts: 0
    },
    {
        id: 13,
        colorClass: 'bg-case',
        icon: 'pi pi-ticket',
        activityNames: ['ActivityFeed'],
        activityName: "Stage Changed",
        types: ['StageChange'],
        subTypes: [],
        counts: 0
    },
    {
        id: 14,
        colorClass: 'bg-note',
        icon: 'pi pi-ticket',
        activityNames: ['ActivityFeed'],
        activityName: "Contact Activities",
        types: ['Contact','ActiveInactiveContactLog'],
        subTypes: [],
        counts: 0
    },
    {
        id: 15,
        colorClass: 'bg-note',
        icon: 'pi pi-ticket',
        activityNames: ['ActivityFeed'],
        activityName: "Resolution Date Update",
        types: ['ResolutionDateChange'],
        subTypes: [],
        counts: 0
    },
    {
        id: 16,
        colorClass: 'bg-opportunity',
        icon: 'pi pi-money-bill',
        activityNames: ['ActivityFeed'],
        activityName: "Opportunity Activities",
        types: ['Opportunity','ActiveInactiveOpportunityLog','ActivityOpportunityLog'],
        subTypes: [],
        counts: 0
    },
    {
        id: 17,
        colorClass: 'bg-opportunity',
        icon: 'pi pi-ticket',
        activityNames: ['ActivityFeed'],
        activityName: "Account Activities",
        types: ['Account','ActivityAccountLog','ActiveInactiveAccountLog'],
        subTypes: [],
        counts: 0
    },
    {
        id: 18,
        colorClass: 'bg-case',
        icon: 'pi pi-ticket',
        activityNames: ['ActivityFeed'],
        activityName: "Lead Activities",
        types: ['Lead','ActivityLeadLog','ActiveInactiveLeadLog'],
        subTypes: [],
        counts: 0
    },
    {
        id: 19,
        colorClass: 'bg-case',
        icon: 'pi pi-ticket',
        activityNames: ['ActivityFeed'],
        activityName: "Case Activities",
        types: ['Case', 'ActivityCasesLog'],
        subTypes: [],
        counts: 0
    },
    {
        id: 20,
        colorClass: 'bg-opportunity',
        icon: 'pi pi-ticket',
        activityNames: ['ActivityFeed'],
        activityName: "Other Activities",
        types: ['EmailReply','Estimate','SalesOrder','ActivitySalesOrderLog',
                'Invoice','CustomerRMA','Invoice Received Payment','CreditMemo','ItemReceipt','Bill'],
        subTypes: [],
        counts: 0
    }
];
